import "./RedirectionBlock.css";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import TextInput from "/src/components/UI/TextField/TextInput";
import ReactTextareaAutosize from "react-textarea-autosize";
import { useState, useRef, useEffect } from "react";

function RedirectionBlock({ name, keywords, forbidden, child, first, idx, deleteValue, setValue, move }) {

    const [open, setOpen] = useState(false);
    const [currentHeight, setCurrentHeight] = useState(0);
    const [errorBug, setErrorBug] = useState(false);
    const [heights, setHeight] = useState(0);
    const refEditArea = useRef();
    
    const [keywordsValue, setKeywordsValue] = useState(keywords);
    const [forbiddenValue, setForbiddenValue] = useState(forbidden);
    const [nameValue, setNameValue] = useState(name);
    const [isHover, setIsHover] = useState(false);
    const getHeight = () => {
        try {
            return document.getElementsByClassName('measuring').item(child.index - 1).clientHeight
        }
        catch {
            setErrorBug(true);
        }

    };

    const setValueRedirection = (name, value) => {
        setValue(child.index - 1, name, value)
    }

    const setValueNameRedirection = (name, value) => {
        setValue(child.index - 1, name, value)
    }

    const onToggle = () => {
        setOpen(!open);

        if (!open == false) {
            setCurrentHeight(0)
        }
        else {
            setCurrentHeight(getHeight())
        }
    }

    const onHeightChange = () => {
        if (currentHeight == 0) {
            return
        }
        setCurrentHeight(getHeight())
    }

    const disableSpellCheck = (ref) => {
        if (!ref) {
            return;
        }
        ref.spellcheck = false
    }

    useEffect(() => {
        if (refEditArea == null) {
            return;
        }

        if (first) {
            setOpen(true);
            setCurrentHeight(getHeight())
        }

        return () => { }
    }, [refEditArea])

    const classNameInput = open ? 'input redirection-contain' : 'input redirection-contain disabled'

    const messageBug = <>An error has occurred and has been reported to us, our team is looking into it.  <br/> <br/> In the meantime,<span style={{fontWeight: 'bold'}}> please create a new box.</span></> // TEMPORAIRE en attendant de fix le probleme
    return (

        <>
            {errorBug == false ?
                <>
                    <div className="redirection_block" onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
                        <TextInput value={nameValue} className={classNameInput} onBlur={() => setValueNameRedirection('name', nameValue)} onChange={(e) => setNameValue(e.target.value)} />
                        <div className="actions">
                            {(isHover && idx != 0 && first != true) && <IconButton onClick={() => move(child, child.index - 1)} className="editor-iconButton main_add-button button_center profil_action" icon="fas fa-chevron-up"></IconButton>}
                            {(isHover && idx != - 1) && <IconButton onClick={() => move(child, child.index + 1)} className="editor-iconButton main_add-button button_center profil_action" icon="fas fa-chevron-down"></IconButton>}
                            <IconButton onClick={onToggle} className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-edit"></IconButton>
                            <IconButton className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" onClick={() => deleteValue(child)} ></IconButton>
                        </div>
                    </div>
                    <div className={open ? "redirection_zone_edit show" : "redirection_zone_edit"} ref={refEditArea} style={{ height: currentHeight }}>
                        <div className="measuring">
                            <div className="container-textarea">
                                <ReactTextareaAutosize ref={(ref) => disableSpellCheck(ref)} onHeightChange={onHeightChange} value={keywordsValue} onBlur={() => setValueRedirection('keywords', keywordsValue)} onChange={(e) => setKeywordsValue(e.target.value)} className="input editor-input title_input" placeholder='Keyword 1; Keyword 2; Keyword 3; etc...' minRows={3} />
                            </div>

                            <div className="container-textarea">
                                <ReactTextareaAutosize ref={(ref) => disableSpellCheck(ref)} onHeightChange={onHeightChange} value={forbiddenValue} onBlur={() => setValueRedirection('forbidden', forbiddenValue)} onChange={(e) => setForbiddenValue(e.target.value)} spellCheck="false" className="input editor-input title_input" placeholder='Forbidden keyword 1; Forbidden keyword 2; Forbidden keyword 3; etc...' minRows={3} />
                            </div>
                        </div>
                    </div>

                </>
                :
                <span style={{ color: 'var(--pink)',paddingLeft:"10px",paddingTop:"10px" }}> {messageBug}</span>
            }

        </>
    )
}

export default RedirectionBlock;